<template>
<div>
  <el-table :data="tableData"
            border default-expand-all
            style="width: 100%;margin-top: 20px"
            :header-cell-style="rowClass">
    <el-table-column label="费用合计" min-width="100%" header-align="left">
      <el-table-column label="分类" prop="taskClass"    min-width="15%" align="center"></el-table-column>
      <el-table-column label="本金" prop="moneyFree" min-width="15%" align="center"></el-table-column>
      <el-table-column label="物流费" prop="expressMoney" min-width="15%" align="center"></el-table-column>
      <el-table-column label="基础服务费" prop="baseServiceMoney" min-width="15%" align="center"></el-table-column>
      <el-table-column label="附加服务费" prop="attachMoney" min-width="15%" align="center"></el-table-column>
      <el-table-column label="好评任务" prop="reviewServiceMoney" min-width="15%" align="center"></el-table-column>
      <el-table-column label="手续费" prop="serviceFee" min-width="15%" align="center"></el-table-column>
      <!--fix bug deleted money reward<el-table-column label="赏金" prop="moneyReward" min-width="15%" align="center"></el-table-column>-->
      <el-table-column label="任务数" prop="taskNumbers" min-width="15%" align="center"></el-table-column>
      <el-table-column label="小计"min-width="15%" align="center">
        <template slot-scope="scope">
          <span >{{priceTotial(scope.row)}}</span>
        </template>
      </el-table-column>
    </el-table-column>
  </el-table>
  <el-table :data="tableData"
            border default-expand-all
            style="width: 100%;border-top: 0px;"
            :show-header="false"
            cell-style="text-align: right; padding-right: 5rem;pointer-events: none">
    <el-table-column min-width="100%">
      <template slot-scope="scope">
        <span>合计金币:&nbsp&nbsp</span>
        <span style="color: crimson;margin-left: 1rem">
          {{pricesTotal()}}
        </span>
        <div>
          <span>合计单数:&nbsp&nbsp</span>
          <span style="color: crimson;margin-left: 1rem">
            {{orderNumTotal()}}&nbsp&nbsp单
          </span>
        </div>
      </template>
    </el-table-column>
  </el-table>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {FloatAdd, FloatMul} from "@/lib/utils"
import {getTaskVoInfo} from "../../api/b2cbusiness/b2c_tasklist";

export default {
  name: "FreePriceDetailComponent",
  props: ["tableFeildAndVal"],
  mixins:[MixinCUD],
  data() {
    return {
      tableData:[

      ],
    }
  },
  mounted() {
    console.log(this.tableFeildAndVal);
    getTaskVoInfo(this.tableFeildAndVal).then(res=>{
      if (res.success){
        for (let data of res.data){
          //this.tableData = [...data.moneyDetails];
          console.log(this.tableData)
          this.buildTableData(data.moneyDetails);
        }
      }
    });
  },
  methods: {
    buildTableData(dataArray) {
      let taskClasss = {};
      for (let data of dataArray){
        data.attachMoney = data.attachMoney !=null?data.attachMoney:0.00;
        //data.moneyFree = FloatAdd(data.moneyFree, data.expressMoney);
        if (Object.keys(taskClasss).indexOf(""+data.taskClass) === -1){
          taskClasss[data.taskClass] = [];
        }
        taskClasss[data.taskClass].push(data);
      }
      for (let taskCls in taskClasss){
        //console.log(taskClasss[taskCls])
        if (taskClasss[taskCls].length > 1){
          taskClasss[taskCls][0].taskNumbers = taskClasss[taskCls].length;
          //console.log(taskClasss[taskCls])
        }
        this.tableData.push(taskClasss[taskCls][0])
      }
      //console.log(this.tableData)
    },
    priceTotial(rowVal){
      let tmp =  FloatAdd(rowVal.serviceFee,FloatAdd(FloatAdd(rowVal.moneyFree, rowVal.baseServiceMoney).toFixed(2), rowVal.attachMoney).toFixed(2)).toFixed(2);
      if (rowVal.expressMoney != null && parseFloat(rowVal.expressMoney) >0){
        tmp = FloatAdd(tmp, parseFloat(rowVal.expressMoney));
      }
      return FloatMul(FloatAdd(FloatAdd(tmp, rowVal.reviewServiceMoney), rowVal.moneyReward).toFixed(2), rowVal.taskNumbers).toFixed(2);
    },
    pricesTotal(){
      let total = "0.00";
      for (let item in this.tableData){
        total = FloatAdd(total, this.priceTotial(this.tableData[item])).toFixed(2);
      }
      return total;
    },
    orderNumTotal(){
      let total = 0;
      for (let item in this.tableData){
        total = FloatAdd(this.tableData[item].taskNumbers, total);
      }
      return total;
    }
  }
}
</script>

<style scoped>

</style>
